export * from "./onetrust-script";
